import script from "./MarketPrices.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketPrices.vue?vue&type=script&setup=true&lang=js"

import "./MarketPrices.vue?vue&type=style&index=0&id=8f37ae66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f37ae66"]])

export default __exports__